import { useEffect, useRef, useState } from "react";
import PeekingMascot from "./PeekingMascot";

const REACT_MS = 1400;
const SETTLED = { valid: "happy", invalid: "sad" };

// Brief mood while `trigger` changes to a new truthy value, then back to null.
function useReaction(trigger, moodFor) {
  const [reaction, setReaction] = useState(null);
  const prev = useRef(trigger);
  useEffect(() => {
    if (trigger === prev.current) return undefined;
    prev.current = trigger;
    const mood = moodFor(trigger);
    if (!mood) return undefined;
    setReaction(mood);
    const t = setTimeout(() => setReaction(null), REACT_MS);
    return () => clearTimeout(t);
  }, [trigger, moodFor]);
  return reaction;
}

const voteMood = (vote) => (vote === true ? "celebrate" : vote === false ? "scared" : null);
const resultMood = (result) => (result === "valid" ? "celebrate" : result === "invalid" ? "sad" : null);

/**
 * An answer card with its author's mascot peeking over the top-right edge.
 * It sits still until something happens: the viewer's vote (a quick cheer
 * or gasp), then the resolved result (happy or sad).
 */
export default function AnswerPeek({ mascot, vote, result, children }) {
  const fromVote = useReaction(vote, voteMood);
  const fromResult = useReaction(result, resultMood);
  const reaction = fromResult || fromVote;
  const mood = reaction || SETTLED[result] || "calm";

  return (
    <PeekingMascot
      mascot={mascot}
      mood={mood}
      width={mascot.base === "pencil" ? 58 : 60}
      right={14}
      still={!reaction}
      bodyClassName={reaction ? "nm-react" : ""}
    >
      {children}
    </PeekingMascot>
  );
}
